import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../components/layout';
import { wsdcc_action, wsdcc_action_names, wsdcc_issue, wsdcc_issue_doc, wsdcc_issue_names } from '../../components/wsdcc';
export const title = "Resolution Help";
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Layout title={title} mdxType="Layout">
      <h1>{title}</h1>
      <p><a parentName="p" {...{
          "href": "https://www.wa-democrats.org/wp-content/uploads/2020/02/WSDCC-Rules-for-Resolutions.pdf"
        }}>{`WSDCC Resolution Rules`}</a></p>
      <p>{`Resolutions should be in a format that can be easily edited.
WSDCC uses MSWord, but Markdown works for version control.`}</p>
      <p><a parentName="p" {...{
          "href": "https://mdxjs.com/"
        }}>{`MDX`}</a>{`, an extension of Markdown, was required for integration with this website.
See an `}<a parentName="p" {...{
          "href": "https://gitlab.com/32democrats/32democrats.gitlab.io/-/blob/master/src/pages/resolutions/2020/R-90.mdx"
        }}>{`example resolution in Markdown`}</a>{` and `}<a parentName="p" {...{
          "href": "/resolutions/2020/R-90"
        }}>{`the result`}</a>{`.`}</p>
      <ul>
        <li parentName="ul"><inlineCode parentName="li">{`title`}</inlineCode>{`, concise`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`title_short`}</inlineCode>{` for headers`}</li>
        <li parentName="ul">{`1-2 pages print preview. 250 words per page is the rule of thumb.`}</li>
        <li parentName="ul">{`2 to 5 “Whereas” statements`}<ul parentName="li">
            <li parentName="ul">{`supported by documented references.`}</li>
            <li parentName="ul">{`(Citations will not be included for passage by the full body but are recommended for context and background for the committee.)`}</li>
          </ul></li>
        <li parentName="ul">{`1 to 3 “Therefore” statements`}</li>
        <li parentName="ul">{`“Whereas” and “Therefore” statements are related.`}</li>
        <li parentName="ul">{`Written from the point of view of the WSDCC.`}</li>
        <li parentName="ul">{`End:`}<ul parentName="li">
            <li parentName="ul">{`organization`}</li>
            <li parentName="ul">{`contact person`}</li>
            <li parentName="ul">{`contact email`}</li>
            <li parentName="ul">{`date submitted`}</li>
          </ul></li>
      </ul>
      <h1>{`Header`}</h1>
      <p>{`Upper right of each page.`}</p>
      <p><inlineCode parentName="p">{`WSDCCRES – 522 – 550918 – SUB – ARTS – Commemorating Star Wars Day`}</inlineCode></p>
      <ul>
        <li parentName="ul">{`organization`}</li>
        <li parentName="ul">{`identifying number`}</li>
        <li parentName="ul">{`date of last action (YYMMDD) `}</li>
        <li parentName="ul">{`Last action`}</li>
        <li parentName="ul">{`issue abbreviation`}</li>
        <li parentName="ul">{`title, shortened`}</li>
      </ul>
      <p>{`To ease formatting, use the component:`}</p>
      <pre>{`<WsdccHeader w={{
  action_date: '2020-01-01',
  number: 1,
  organization: 'WSDCC',
  title_short: 'Title',
  wsdcc_action: wsdcc_action.submitted,
  wsdcc_issue: wsdcc_issue.unknown,
}}/>`}</pre>
      <p>{`Use a `}<inlineCode parentName="p">{`wsdcc_action`}</inlineCode>{`, which is an unambiguous mapping for WSDCC actions.`}</p>
      <ul>
        {Object.entries(wsdcc_action).map(([name, id]) => <li><code>{name}</code>: {wsdcc_action_names[id]}</li>)}
      </ul>
      <h2>{`Issues and Abbreviations`}</h2>
      <p>{`Select a `}<inlineCode parentName="p">{`wsdcc_issue`}</inlineCode>{`, which is an unambiguous mapping for WSDCC abbreviations.`}</p>
      <ul>
        {Object.entries(wsdcc_issue).map(([name, id]) => <li><code>{name}</code>: {wsdcc_issue_doc[id]} ({wsdcc_issue_names[id]})</li>)}
      </ul>
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      